import type { Catalog } from "../../en";
import { analytics } from "./analytics";
import { announcements } from "./announcements";
import { gaps } from "./gaps";
import { inbox } from "./inbox";
import { bookings } from "./bookings";
import { leads } from "./leads";
import { routing } from "./routing";
import { workflows } from "./workflows";

/** Filipino: engage group (mirrors en/engage). */
export const engage: Catalog["engage"] = {
  time: {
    now: "ngayon",
    minutes_one: "{{count}}m",
    minutes_other: "{{count}}m",
    hours_one: "{{count}}h",
    hours_other: "{{count}}h",
    yesterday: "Kahapon",
  },
  planGate: {
    title: "Hindi kasama ang {{feature}} sa plan mo",
    body: "Mag-upgrade ng plan para magamit ito ng workspace mo.",
    bodyPlan: "Available ang {{feature}} sa {{plan}} plan at mas mataas. Mag-upgrade para magamit ito ng workspace mo.",
    upgrade: "Tingnan ang mga plan",
  },
  channels: {
    widget: "Widget",
    webapp: "Web app",
    mobile: "Mobile app",
    messenger: "Messenger",
    email: "Email",
    api: "API",
    playground: "Playground",
    slack: "Slack",
    teams: "Teams",
  },
  allAgents: "Lahat ng agent",
  allChannels: "Lahat ng channel",
  export: "I-export",
  exportFailed: "Hindi ma-download ang export. Pakisubukang muli.",
  noPermission: "Wala kang permission na gawin ito.",
  saveFailed: "Hindi na-save. Pakisubukang muli.",
  loadMore: "Mag-load pa",
  inbox,
  gaps,
  leads,
  bookings,
  routing,
  announcements,
  analytics,
  workflows,
};
